import React, { useState, useContext } from 'react';

import spanish from '../../images/langs/spanish.png';
import english from '../../images/langs/english.png';
import italian from '../../images/langs/it.png';
import hungarian from '../../images/langs/hu.jpg';



import es from '../../constants/es';
import en from '../../constants/en';
import it from '../../constants/it';
import si from '../../constants/si';

export const LanguageData = {
  lang: "langFLIER"
}

export const dictionaryList = {
  es, en, it, si
};

export const languageOptions = [
  { id: 'en', text: 'English', image: english },
  { id: 'es', text: 'Español', image: spanish },
  { id: 'it', text: 'Italiano', image: italian },
  { id: 'si', text: 'Slovenščina', image: hungarian },
];

export const langKey = (context, key) => `${key}${context.language.id === "es" ? "En" : "En"}`

const getCookieLang = () => {
  let lang = localStorage.getItem(LanguageData.lang);
  if (lang && languageOptions.filter(language => language.id == lang).length > 0) {
    const selectedLang = languageOptions.filter(language => language.id == lang)[0];
    return { language: selectedLang, dictionary: dictionaryList[selectedLang.id] };
  }

  return {
    language: navigator.language.includes("es") ? languageOptions[1] : languageOptions[0],
    dictionary: dictionaryList[navigator.language.includes("es") ? languageOptions[1].id : languageOptions[0].id]
  }
}

export const LanguageContext = React.createContext(getCookieLang());

// it provides the language context to app
export function LanguageProvider(props) {
  const languageContext = useContext(LanguageContext);
  const [language, setLanguage] = useState(languageContext.language);
  const [dictionary, setDictionary] = useState(languageContext.dictionary);

  const provider = {
    language,
    dictionary,
    setLanguage: (selectedLanguage) => {
      setLanguage(selectedLanguage); // it will update the language in state
      setDictionary(dictionaryList[selectedLanguage.id]);
    }
  };

  return <LanguageContext.Provider value={provider} children={props.children} />;
};